module.exports = __webpack_public_path__ + "static/media/LOGO_COMPARA_CORSI_BIANCO-1536x217.4b8c2dd0.webp";